/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */
import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export const NotFoundPage: FC = () => {
  const notFoundMsg = useLocale().notFound;
  return (
    <PageLayout>
      <Helmet title={notFoundMsg.title} />
      <h1 className='text-level-3 my-lg'>{notFoundMsg.header}</h1>
      <p>{notFoundMsg.message}</p>
      <Link to='/'>{notFoundMsg.continueMessage}</Link>
    </PageLayout>
  );
};
